// LIBRARIES
import styled, { css } from "styled-components";
import CancelIcon from "@mui/icons-material/Cancel";
import PhoneIcon from "@mui/icons-material/Phone";
import MailIcon from "@mui/icons-material/Mail";

// MISC
import { COLORS, FONTS } from "constants/styleVariables";

export const ModalContainer = styled.div`
  height: 600px;
  width: 950px;
  border-radius: 20px;
  background-color: ${COLORS.primaryWhite};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  outline: none;
`;

export const TopContainer = styled.div`
  height: 180px;
  width: 950px;
  border-radius: 20px;
  background-image: linear-gradient(
    266deg,
    ${COLORS.rainbowIndigo} 0%,
    ${COLORS.rainbowIndigo} 100%
  );
  box-shadow: -5px 5px 10px ${COLORS.fifthBlack};
  display: flex;
  flex-direction: column;
`;

export const CloseIconContainer = styled.div`
  position: absolute;
  padding-left: 906px;
  padding-top: 20px;
`;

export const CloseIcon = styled(CancelIcon)`
  && {
    color: ${COLORS.thirdGray};
    padding: 0;
    margin-bottom: 0;
    cursor: pointer;
  }
`;

export const TopContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: 40px;
  align-items: center;
  justify-content: space-between;
`;

export const UserImageContainer = styled.img`
  width: 100px;
  height: 100px;
  background-color: ${COLORS.thirdGray};
  border-radius: 50%;
  box-shadow: -5px 5px 10px ${COLORS.fifthBlack};
`;

export const UserInfoTopContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 20px;
`;

export const UserNameContainer = styled.div`
  font-family: ${FONTS.newsharp};
  font-size: 20px;
  letter-spacing: 0.8px;
  color: ${COLORS.primaryWhite};
`;

export const UserStatusContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 5px;
  font-family: ${FONTS.montserrat};
`;

export const Dot = styled.div(
  ({ color }) => css`
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background-color: ${color ? color : "transparent"};
  `
);

export const StatusValue = styled.div(
  ({ color }) => css`
    color: ${color ? color : "transparent"};
    margin-left: 10px;
    font-size: 14px;
  `
);

export const BottomContainer = styled.div`
  margin: 20px 20px 20px 20px;
  padding-left: 20px;
  background-color: transparent;
  height: 100%;
  display: flex;
  flex-direction: column;
  /* overflow: hidden;
  overflow-y: auto;
  ::-webkit-scrollbar {
    width: 4px;
  }
  ::-webkit-scrollbar-track {
    background-color: ${COLORS.backgroundColor};
    border-radius: 10px;
    margin-block: 9px;
    margin-left: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background-image: linear-gradient(
      180deg,
      ${COLORS.cornflowerBlue} 0%,
      ${COLORS.rainbowIndigo} 100%
    );
    border-radius: 10px;
  } */
`;

export const UserInfoBottomContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`;

export const UserContactInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BottomSubtitle = styled.div`
  font-family: ${FONTS.montserrat};
  letter-spacing: 0px;
  text-align: left;
  font-weight: 600;
  color: ${COLORS.secondaryBlack};
  margin-bottom: 20px;
`;

export const UserInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const UserInfoLine = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
  align-items: center;
`;

export const IconPhone = styled(PhoneIcon)`
  && {
    color: ${COLORS.rainbowIndigo};
  }
`;

export const IconMail = styled(MailIcon)`
  && {
    color: ${COLORS.rainbowIndigo};
  }
`;

export const UserInfo = styled.div`
  font-family: ${FONTS.montserrat};
  font-size: 16px;
  letter-spacing: 0.64px;
  color: ${COLORS.primaryGray};
  font-weight: 600;
  margin-left: 10px;
`;

export const UserIdWrapper = styled.div`
  display: flex;
  flex-direction: column;
  /* margin-left: 80px; */
`;

export const UserIdImagesWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const UserIdImageContainer = styled.img`
  width: 140px;
  height: 80px;
  margin-right: 20px;
`;

export const UserDetailsActionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const SelectInputAtomContainer = styled.div`
  & .MuiInputBase-root {
    height: 40px;
    align-items: center;
  }
`;

export const SendMessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 570px;
`;

export const SendMessageContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
`;

export const SendMessageAdminIcon = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
  box-shadow: -5px 5px 10px ${COLORS.fifthBlack};
`;

export const InputAtomContainer = styled.div(
  ({ width }) => css`
    width: ${width ? width : "460px"};
    & .MuiInputBase-root {
      height: 40px;
      align-items: center;
    }
  `
);

export const SendMessageIcon = styled.img`
  width: 40px;
  height: 40px;
  margin-left: 20px;
`;

export const MessagesContainer = styled.div`
  width: 100%;
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;

export const MessageHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;

export const User = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: ${FONTS.newsharp};
  font-size: 18px;
  color: ${COLORS.cornflowerBlue};
`;

export const Date = styled.div`
  font-family: ${FONTS.montserrat};
  font-size: 14px;
  color: ${COLORS.primaryGray};
  letter-spacing: 0.56px;
  font-weight: 600;
`;

export const MessageContent = styled.div`
  font-family: ${FONTS.montserrat};
  font-size: 14px;
  color: ${COLORS.sixthBlack};
  width: 100%;
  font-weight: 600;
`;

export const SelectStatusWrapper = styled.div`
  margin-left: 60px;
  display: flex;
  flex-direction: column;
`;
export const UserRentalsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  padding: 0 40px;
  color: blue;
  overflow: hidden;
  overflow-x: auto;
  ::-webkit-scrollbar {
    width: 4px;
  }
  ::-webkit-scrollbar-track {
    background-color: ${COLORS.backgroundColor};
    border-radius: 10px;
    margin-block: 9px;
    margin-left: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background-image: linear-gradient(
      180deg,
      ${COLORS.rainbowIndigo} 0%,
      ${COLORS.rainbowIndigo} 100%
    );
    border-radius: 10px;
  }
`;

export const UserRentalId = styled.text`
  font-size: 14px;
`;

export const UserRentalContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: white;
  padding: 15px;
  min-width: 255px;
  height: 120px;
  background-color: ${COLORS.rainbowIndigo};
  border-radius: 20px;
  margin-right: 50px;
  margin-bottom: 50px;
  font-family: ${FONTS.montserrat};
  font-weight: 600;
`;

export const UserLeftContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const UserRentalStatus = styled.text`
  font-size: 12px;
`;

export const UserRightContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const UserRentalTime = styled.text`
  font-size: 10px;
  margin-bottom: 7px;
`;

export const UserRentalsContent = styled.div`
  display: flex;
  flex-direction: column;
`;
export const UserRentalsTitle = styled.text`
  margin-left: 40px;
  font-size: 16px;
  margin-bottom: 40px;
  font-family: ${FONTS.montserrat};
  letter-spacing: 0px;
  text-align: left;
  font-weight: 600;
  color: ${COLORS.secondaryBlack};
`;

export const BlackListButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const UserContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
